import { formatDecimalNumber } from "../../../Common/DetailsForm/Presenter/Helpers/formatDecimalNumber";
import type { ContractWithdrawalItemViewModel } from "../Vm/ContractWithdrawalItemViewModel";

export default function ContractWithdrawalItemDisplayFragment(props: {
  items: ContractWithdrawalItemViewModel[];
  onRemoveItem: (index: number) => void;
  onEditItem: (index: number) => void;
  onNewItem: () => void;
  isNewItemEnabled: boolean;
  onOpenDocumentSelector: () => void;
}) {
  return (
    <>
      {props.items.length > 0 && (
        <table
          className="table table-striped"
          style={{ backgroundColor: "rgba(248, 249, 250, 0.8)" }}
        >
          <thead>
            <tr>
              <th>Poz.</th>
              <th>Kod pozycji</th>
              <th>Nazwa towaru</th>
              <th>Numer katalogowy</th>
              <th className="text-center">Ilość do zwrotu</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {props.items.map((item, index) => (
              <tr key={item.id}>
                <td className="text-end">{index + 1}</td>
                <td>{item.documentItem?.lineCode}</td>
                <td>{item.documentItem?.productName}</td>
                <td>{item.documentItem?.catalogNumber}</td>
                <td className="text-end">
                  {formatDecimalNumber(
                    // biome-ignore lint/style/noNonNullAssertion: only items saved by the validated item form are displayed in this table
                    item.amount!,
                    4,
                  )}
                </td>
                <td>
                  {/** biome-ignore lint/a11y/useValidAnchor: button link causes layout problems */}
                  {/** biome-ignore lint/a11y/useSemanticElements: button link causes layout problems */}
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      props.onRemoveItem(index);
                    }}
                    href="#"
                    role="button"
                    className="link-danger me-3 small text-decoration-none"
                    title="Kliknij, aby usunąć tę pozycję z formularza."
                  >
                    <i className="bi bi-trash3 ps-2"></i> Usuń
                  </a>
                  {/** biome-ignore lint/a11y/useValidAnchor: button link causes layout problems */}
                  {/** biome-ignore lint/a11y/useSemanticElements: button link causes layout problems */}
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      props.onEditItem(index);
                    }}
                    href="#"
                    role="button"
                    className="link-primary small text-decoration-none"
                    title="Kliknij, aby zmienić zawartość tej pozycji."
                  >
                    <i className="bi bi-pencil-square"></i> Edytuj
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {props.items.length === 0 && (
        <div className="row mb-3">
          <div className="col-sm-12">
            <div
              className="alert alert-primary d-flex align-items-center"
              role="alert"
            >
              <div className="flex-shrink-0 ms-3 me-4">
                <i className="bi bi-lightbulb"></i>
              </div>
              <div>
                <b>Brak pozycji</b>
                <br />
                Przed wysłaniem formularza musisz dodać co najmniej jedną
                pozycję, której dotyczy odstąpienie od umowy.
                {!props.isNewItemEnabled && (
                  <>
                    <br />
                    <b>Faktura nie została wybrana</b>
                    <br />
                    Aby dodać pozycję, musisz najpierw{" "}
                    {/** biome-ignore lint/a11y/useValidAnchor: button link causes layout problems */}
                    {/** biome-ignore lint/a11y/useSemanticElements: button link causes layout problems */}
                    <a
                      role="button"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        props.onOpenDocumentSelector();
                      }}
                      className="alert-link"
                    >
                      <b>wybrać fakturę</b>.
                    </a>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="row mb-3">
        <div className="col-sm-12">
          <button
            type="button"
            onClick={props.onNewItem}
            className="btn btn-success py-1 ps-4 pe-5"
            disabled={!props.isNewItemEnabled}
          >
            <i className="bi bi-plus-circle ps-2 me-2"></i> Dodaj pozycję
          </button>
        </div>
      </div>
    </>
  );
}
